<template>
<pop-up-layout 
  :title="titulo"
  :description="description"
  :aceptar="$t('general.misc.eliminar')"
  :loadingText="$t('general.misc.cargando')"
  @volver="$parent.hide()"
  @aceptar="$emit('continuar')"
>
  <v-container fluid>
    <v-layout column justify-center align-center ml-4 mr-4>
      <img style="margin-top: 30px; margin-bottom: 30px; width:150px; height:150px;" src="~@/assets/images/WARNING_GRIS.png"/>
    </v-layout>
  </v-container>
</pop-up-layout>
</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: null
    }
  },
  data () {
    return {

    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/reservas/kyc/KycBorrar.vue